export default {
    baseStyle: {
        wrapper: {
            position: 'absolute',
            top: '0',
            padding: '10px',
            textAlign: 'center'
        },
        title: {
            fontSize: {base: '36px', lg: '48px'},
            letterSpacing: '0.24px',
            lineHeight: {base: '32px', lg: '48px'},
            fontWeight: '400',
            display: 'flex',
            alignItems: 'center'
        },
        titleDollarSign: {
            width: {base: '11px', lg: '14px'},
            height: 'auto'
        },
        subTitle: {
            fontSize: {base: '18px', lg: '24px'},
            letterSpacing: '0.12px',
            lineHeight: '18px',
            fontWeight: '400'
        }
    },
    variants: {
        promoGridFourItems: {
            wrapper: {
                padding: {base: '5px', md: '10px'}
            },
            title: {
                fontSize: {base: '24px', xs: '32px', md: '48px'},
                letterSpacing: {base: '0.08px', xs: '0.16px', md: '0.24px'},
                lineHeight: {base: '24px', xs: '36px', md: '54px'},
                fontWeight: '400'
            },
            subTitle: {
                fontSize: {base: '14px', xs: '16px', md: '24px'},
                letterSpacing: {base: '0.06px', xs: '0.12px', md: '0.12px'},
                lineHeight: {base: '16px', xs: '18px'},
                fontWeight: '400'
            }
        }
    },
    parts: ['wrapper', 'title', 'subTitle'],
    defaultProps: {
        variant: 'default'
    }
}
